import React, { useCallback } from "react";

import { Button, Col, Container, Modal, Row } from "react-bootstrap";

import classNames from "classnames";
import { isUndefined } from "lodash";
import { ReactSVG } from "react-svg";

import { WarningIcon } from "../assets/icons";
import { useClearError, useGetError } from "../context/error";

import styles from "./ErrorModal.module.scss";

export const ErrorModal = () => {
  const error = useGetError();
  const clearError = useClearError();
  const isOpen = !isUndefined(error);

  const handleCloseModal = useCallback(() => clearError(), [clearError]);

  return (
    <Modal className={styles["error-modal"]} show={isOpen} centered size="lg">
      <Modal.Body className="p-0">
        <Container className="p-0" fluid>
          <Row>
            <Col>
              <ReactSVG className={classNames(styles["warning-icon"])} src={WarningIcon} />
            </Col>
          </Row>
          <Row className="mt-4 mb-2">
            <Col xs={12} className="text-center">
              <h1>Error!</h1>
            </Col>
          </Row>
          <Row className="mb-5">
            <Col xs={12} className="text-center">
              {error?.errorMessages.map((errorMessage) => (
                <div key={errorMessage} className="b2">
                  {errorMessage}
                </div>
              ))}
            </Col>
          </Row>
          <Row className="text-center mb-5">
            <Col>
              <Button variant="primary" onClick={handleCloseModal}>
                Close
              </Button>
            </Col>
          </Row>
        </Container>
      </Modal.Body>
    </Modal>
  );
};
